import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    SCNResponseLegacyAPI,
    SCNResponseAPI,
    SCNResponseReportsResponse,
    GetSCNResponseParams,
    PutSCNResponseLegacyRequest,
    PutSCNResponseRequest,
} from "../../../../../api/scnResponseReports";

import { MessageResponse } from "../../../../../api/common";


/**
 * =========================================
 * Legacy Thunks
 * =========================================
 */

export const fetchSCNResponseReportsLegacyThunk = createAsyncThunk<
    SCNResponseReportsResponse,
    { case_id: string } & GetSCNResponseParams,
    { rejectValue: string }
>(
    "reports/fetchSCNResponses",
    async (params, { rejectWithValue }) => {
        try {
            return await SCNResponseLegacyAPI.get_scn_response(params);
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to fetch SCN Response reports");
        }
    }
);

export const putSCNResponseLegacyThunk = createAsyncThunk<
    MessageResponse,
    PutSCNResponseLegacyRequest,
    { rejectValue: string }
>(
    "reports/putSCNResponse",
    async (params, { rejectWithValue }) => {
        try {
            return await SCNResponseLegacyAPI.put_scn_response(params);
        } catch (error: any) {
            return rejectWithValue(error.message || "Failed to update SCN response");
        }
    }
);


/**
 * =========================================
 * V2 Thunks
 * =========================================
 */

export const fetchSCNResponseReportsThunk = createAsyncThunk<
    SCNResponseReportsResponse,
    { case_id: string } & GetSCNResponseParams,
    { rejectValue: string }
>(
    "reports/fetchSCNResponsesV2",
    async (params, { rejectWithValue }) => {
        try {
            return await SCNResponseAPI.get_scn_response_reports(params);
        } catch (error: any) {
            return rejectWithValue(
                error.message || "Failed to fetch SCN Response reports"
            );
        }
    }
);

export const putSCNResponseThunk = createAsyncThunk<
    MessageResponse,
    { case_id: string; report_id: string; request: PutSCNResponseRequest },
    { rejectValue: string }
>(
    "reports/putSCNResponseV2",
    async ({ case_id, report_id, request }, { rejectWithValue }) => {
        try {
            return await SCNResponseAPI.put_scn_response_report(case_id, report_id, request);
        } catch (error: any) {
            return rejectWithValue(
                error.message || "Failed to update SCN response"
            );
        }
    }
);